import { useEffect, useState } from 'react';
import { DeviceInfo, ONE_LINK_URL, useDevice } from 'common/utils';
import Image from 'next/image';
import { useRouter } from 'next/router';
import Link from 'next/link';
import styles from './PromotionBanner.module.scss';
import useGlobalStore from 'store/global';
// import { SITE_BASE_URL } from 'config/env';

const MobilePromotionBanner = (): JSX.Element => {
  const { pathname } = useRouter();
  const deviceInfo: DeviceInfo = useDevice();
  const [show, setShow] = useState(true);
  const isCampaignPage = pathname.startsWith('/cmp/');
  const isWebFunctionPage = pathname.startsWith('/p/');
  const isLpPage = pathname.startsWith('/lp/');
  const isCoursesPage = pathname.startsWith(`/courses`);
  const isShowingAnimeCharacter = useGlobalStore(
    (state) => state.isShowingAnimeCharacter
  );

  // hide banner when user click on anime icon
  useEffect(() => {
    if (isShowingAnimeCharacter) setShow(false);
  }, [isShowingAnimeCharacter]);
  if (isCampaignPage || isWebFunctionPage || isLpPage || isCoursesPage)
    return <></>;
  if (!show || deviceInfo.isDesktop) return <></>;
  return (
    <div className={styles.banner}>
      <div className={styles.close} onClick={() => setShow(false)}>
        x
      </div>
      <div className={styles.content}>
        <div className={styles.image}>
          <Image
            src="/images/app-icon-1.png"
            width={60}
            height={60}
            alt="logo"
          />
        </div>
        <div className={styles.desc}>
          <p className={styles.title}>PostPrime</p>
          <p className={styles.company}>アプリで使おう！</p>
        </div>
        <div className={styles.jump}>
          <Link href={ONE_LINK_URL}>
            <a className={styles.link}>開く</a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MobilePromotionBanner;
